import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Globals } from '../../Globals'
import storage from 'local-storage-fallback';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public globals: Globals, private myRoute: Router){}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if(this.globals.user || storage.getItem('token')){
      return true;
    }else{
      this.myRoute.navigate(["auth/login"]);
    }
  }
}